import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as s from "react";

function a(e) {
  var n = s.useRef(e);
  return s.useEffect(function () {
    n.current = e;
  }), s.useMemo(function () {
    return function () {
      var _t;

      var t;

      for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
        o[_key] = arguments[_key];
      }

      return (t = n.current) == null ? void 0 : (_t = t).call.apply(_t, [n].concat(o));
    };
  }, []);
}

function R(_ref) {
  var e = _ref.prop,
      n = _ref.defaultProp,
      _ref$onChange = _ref.onChange,
      o = _ref$onChange === void 0 ? function () {} : _ref$onChange;

  var _C = C({
    defaultProp: n,
    onChange: o
  }),
      _C2 = _slicedToArray(_C, 2),
      t = _C2[0],
      c = _C2[1],
      r = e !== void 0,
      i = r ? e : t,
      l = a(o),
      d = s.useCallback(function (u) {
    if (r) {
      var f = typeof u == "function" ? u(e) : u;
      f !== e && l(f);
    } else c(u);
  }, [r, e, c, l]);

  return [i, d];
}

function C(_ref2) {
  var e = _ref2.defaultProp,
      n = _ref2.onChange;

  var o = s.useState(e),
      _o = _slicedToArray(o, 1),
      t = _o[0],
      c = s.useRef(t),
      r = a(n);

  return s.useEffect(function () {
    c.current !== t && (r(t), c.current = t);
  }, [t, c, r]), o;
}

export { R as useControllableState };